import { render, staticRenderFns } from "./IntElement.vue?vue&type=template&id=604ee6c4&"
import script from "./IntElement.vue?vue&type=script&lang=js&"
export * from "./IntElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports